// ===========================
// Animation Controller
// ===========================
document.addEventListener('DOMContentLoaded', ()=>{
    initScrollAnimations();
    initCounterAnimations();
});
// ===========================
// Scroll-triggered Animations
// ===========================
function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.scroll-reveal');
    if (animatedElements.length === 0) return;
    // Create intersection observer
    const observerOptions = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) entry.target.classList.add('revealed');
        });
    }, observerOptions);
    // Observe all animated elements
    animatedElements.forEach((element)=>{
        observer.observe(element);
    });
}
// ===========================
// Counter Animation (for stats)
// ===========================
function initCounterAnimations() {
    const counters = document.querySelectorAll('.stat-number');
    if (counters.length === 0) return;
    const observerOptions = {
        threshold: 0.5
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
                animateCounter(entry.target);
                entry.target.classList.add('counted');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    counters.forEach((counter)=>{
        observer.observe(counter);
    });
}
function animateCounter(element) {
    const text = element.textContent;
    const hasPlus = text.includes('+');
    const number = parseInt(text.replace(/\D/g, ''));
    // Skip if not a number or if it's "100%" (percentage)
    if (isNaN(number) || text.includes('%')) return;
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;
    const increment = number / steps;
    let current = 0;
    element.textContent = '0';
    const timer = setInterval(()=>{
        current += increment;
        if (current >= number) {
            element.textContent = number + (hasPlus ? '+' : '');
            clearInterval(timer);
        } else element.textContent = Math.floor(current) + (hasPlus ? '+' : '');
    }, stepDuration);
}
// ===========================
// Parallax Effect (Optional Enhancement)
// ===========================
function initParallax() {
    const parallaxElements = document.querySelectorAll('.parallax');
    if (parallaxElements.length === 0) return;
    window.addEventListener('scroll', ()=>{
        const scrolled = window.pageYOffset;
        parallaxElements.forEach((element)=>{
            const speed = element.dataset.speed || 0.5;
            const yPos = -(scrolled * speed);
            element.style.transform = `translateY(${yPos}px)`;
        });
    });
}
// ===========================
// Fade In on Scroll (Alternative to Intersection Observer)
// ===========================
function initFadeOnScroll() {
    const fadeElements = document.querySelectorAll('.fade-in, .slide-up');
    if (fadeElements.length === 0) return;
    const checkFade = ()=>{
        fadeElements.forEach((element)=>{
            const elementTop = element.getBoundingClientRect().top;
            const elementBottom = element.getBoundingClientRect().bottom;
            const windowHeight = window.innerHeight;
            // Check if element is in viewport
            if (elementTop < windowHeight - 100 && elementBottom > 0) element.style.animationPlayState = 'running';
        });
    };
    // Initial check
    checkFade();
    // Check on scroll (throttled for performance)
    let ticking = false;
    window.addEventListener('scroll', ()=>{
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                checkFade();
                ticking = false;
            });
            ticking = true;
        }
    });
}
// ===========================
// Stagger Animation Helper
// ===========================
function staggerAnimation(elements, animationClass, delay = 100) {
    elements.forEach((element, index)=>{
        setTimeout(()=>{
            element.classList.add(animationClass);
        }, index * delay);
    });
}
// ===========================
// Hover Effects Enhancement
// ===========================
function initHoverEffects() {
    // Add tilt effect to cards
    const cards = document.querySelectorAll('.playlist-card, .resource-card');
    cards.forEach((card)=>{
        card.addEventListener('mouseenter', function() {
            this.style.transition = 'all 0.3s ease';
        });
        card.addEventListener('mousemove', function(e) {
            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const centerX = rect.width / 2;
            const centerY = rect.height / 2;
            const rotateX = (y - centerY) / 20;
            const rotateY = (centerX - x) / 20;
            this.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-5px)`;
        });
        card.addEventListener('mouseleave', function() {
            this.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateY(0)';
        });
    });
}
// ===========================
// Loading Animation
// ===========================
function showLoadingSpinner(container) {
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-label', "\u05D8\u05D5\u05E2\u05DF...");
    if (container) container.appendChild(spinner);
    return spinner;
}
function hideLoadingSpinner(spinner) {
    if (spinner && spinner.parentNode) spinner.parentNode.removeChild(spinner);
}
// ===========================
// Smooth Reveal for Images
// ===========================
function initImageReveal() {
    const images = document.querySelectorAll('img[data-src]');
    if (images.length === 0) return;
    const imageObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.classList.add('fade-in');
                observer.unobserve(img);
            }
        });
    });
    images.forEach((img)=>imageObserver.observe(img));
}
// ===========================
// Export Animation Functions
// ===========================
window.emathAnimations = {
    staggerAnimation,
    showLoadingSpinner,
    hideLoadingSpinner,
    animateCounter
};
// ===========================
// Reduced Motion Support
// ===========================
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
if (prefersReducedMotion.matches) {
    // Disable animations for users who prefer reduced motion
    document.documentElement.style.setProperty('--transition-base', '0ms');
    document.documentElement.style.setProperty('--transition-slow', '0ms');
}
// Listen for changes in motion preference
prefersReducedMotion.addEventListener('change', ()=>{
    if (prefersReducedMotion.matches) {
        document.documentElement.style.setProperty('--transition-base', '0ms');
        document.documentElement.style.setProperty('--transition-slow', '0ms');
    } else {
        document.documentElement.style.setProperty('--transition-base', '200ms');
        document.documentElement.style.setProperty('--transition-slow', '300ms');
    }
});

//# sourceMappingURL=emath.co.il.1ffaff2f.js.map
